import React from 'react';

const SuspenseLoader = () => (
  <div
    style={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <div style={{ width: '40%' }}>
      <svg viewBox='0 0 194 32'>
        <use xlinkHref='#icon-logo' />
      </svg>
      <br />
      <br />
      <svg fill='var(--main-color-text)' viewBox='0 0 194 32'>
        <use xlinkHref='#icon-loader' />
      </svg>
    </div>
  </div>
);

export default SuspenseLoader;
